var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Modal, message, Image, Button as AntButton } from 'antd';
import { CloseOutlined, CheckCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { useConfirmNewSchemeMutation, useDeleteNewSchemeMutation, useGetNewSchemesByRestIdQuery, useUploadMapsDirectMutation, } from '@/services/schemesApi';
import Loader from '@/components/Loader/Loader';
var SchemesTab = function (_a) {
    var restId = _a.restId;
    var _b = useGetNewSchemesByRestIdQuery(restId), _c = _b.data, schemes = _c === void 0 ? [] : _c, isLoading = _b.isLoading, refetch = _b.refetch;
    var deleteNewScheme = useDeleteNewSchemeMutation()[0];
    var confirmNewScheme = useConfirmNewSchemeMutation()[0];
    var uploadMapsDirect = useUploadMapsDirectMutation()[0];
    var _d = useState(null), visibleIndex = _d[0], setVisibleIndex = _d[1];
    var _e = useState(false), showUploadModal = _e[0], setShowUploadModal = _e[1];
    var _f = useState([]), selectedFiles = _f[0], setSelectedFiles = _f[1];
    var handleDeleteScheme = function (id) {
        Modal.confirm({
            title: 'Удалить схему?',
            content: 'Вы действительно хотите удалить эту схему?',
            okText: 'Удалить',
            okType: 'danger',
            cancelText: 'Отмена',
            onOk: function () {
                return __awaiter(void 0, void 0, void 0, function () {
                    var error_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, deleteNewScheme(id).unwrap()];
                            case 1:
                                _a.sent();
                                message.success('Схема удалена');
                                refetch();
                                return [3 /*break*/, 3];
                            case 2:
                                error_1 = _a.sent();
                                message.error('Ошибка при удалении схемы');
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            },
        });
    };
    var handleConfirmScheme = function (schemeId) {
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                Modal.confirm({
                    title: 'Подтвердить схему?',
                    content: 'Схема попадёт в раздел «Подтверждённые», пользователю будет начислена награда. В карты ресторана схема не добавляется.',
                    okText: 'Подтвердить',
                    cancelText: 'Отмена',
                    onOk: function () {
                        return __awaiter(void 0, void 0, void 0, function () {
                            var err_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, confirmNewScheme(schemeId).unwrap()];
                                    case 1:
                                        _a.sent();
                                        message.success("\u0421\u0445\u0435\u043C\u0430 \u2116".concat(schemeId, " \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0430, \u043D\u0430\u0433\u0440\u0430\u0434\u0430 \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u0430 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E"));
                                        refetch();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        err_1 = _a.sent();
                                        console.error(err_1);
                                        message.error('Ошибка при подтверждении схемы');
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        });
                    },
                });
                return [2 /*return*/];
            });
        });
    };
    var handleFileSelect = function (e) {
        var files = Array.from(e.target.files || []);
        setSelectedFiles(files);
    };
    var handleUpload = function () {
        return __awaiter(void 0, void 0, void 0, function () {
            var formData, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (selectedFiles.length === 0) {
                            message.error('Выберите файлы для загрузки');
                            return [2 /*return*/];
                        }
                        formData = new FormData();
                        formData.append('restaurantId', restId.toString());
                        selectedFiles.forEach(function (file) {
                            formData.append('files', file);
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, uploadMapsDirect(formData).unwrap()];
                    case 2:
                        _a.sent();
                        message.success('Схемы успешно загружены в карты ресторана');
                        setShowUploadModal(false);
                        setSelectedFiles([]);
                        refetch();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        message.error('Ошибка при загрузке схем');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    if (isLoading) {
        return (_jsx(LoaderContainer, { children: _jsx(Loader, {}) }));
    }
    return (_jsxs(Container, { children: [_jsxs(Header, { children: [_jsx(Title, { children: "\u0421\u0445\u0435\u043C\u044B \u0437\u0430\u043B\u0430" }), _jsx(AddButton, __assign({ onClick: function () { return setShowUploadModal(true); } }, { children: "+ \u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0445\u0435\u043C\u0443" }))] }), _jsx("p", __assign({ style: { fontSize: 12, color: '#666', marginBottom: 16 } }, { children: "\u0417\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043D\u044B\u0435 \u0437\u0434\u0435\u0441\u044C \u0441\u0445\u0435\u043C\u044B \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u044E\u0442\u0441\u044F \u0441\u0440\u0430\u0437\u0443 \u0432 \u043A\u0430\u0440\u0442\u044B \u0440\u0435\u0441\u0442\u043E\u0440\u0430\u043D\u0430. \u041D\u0438\u0436\u0435 \u2014 \u0441\u0445\u0435\u043C\u044B \u043E\u0442 \u043F\u043E\u0441\u0435\u0442\u0438\u0442\u0435\u043B\u0435\u0439 (\u0438\u0437 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F) \u043D\u0430 \u043C\u043E\u0434\u0435\u0440\u0430\u0446\u0438\u0438." })), schemes.length === 0 ? (_jsxs(EmptyState, { children: [_jsx(EmptyText, { children: "\u041D\u0435\u0442 \u0441\u0445\u0435\u043C \u043E\u0442 \u043F\u043E\u0441\u0435\u0442\u0438\u0442\u0435\u043B\u0435\u0439 \u043D\u0430 \u043C\u043E\u0434\u0435\u0440\u0430\u0446\u0438\u0438" }), _jsx(EmptySubtext, { children: "\u0421\u0445\u0435\u043C\u044B, \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043D\u044B\u0435 \u043A\u043D\u043E\u043F\u043A\u043E\u0439 \u00AB\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0445\u0435\u043C\u0443\u00BB, \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u044E\u0442\u0441\u044F \u0441\u0440\u0430\u0437\u0443 \u0432 \u0440\u0430\u0437\u0434\u0435\u043B \u00AB\u041A\u0430\u0440\u0442\u0430 \u0437\u0430\u043B\u0430\u00BB" })] })) : (_jsx(SchemesGrid, { children: _jsx(Image.PreviewGroup, __assign({ preview: {
                        visible: visibleIndex !== null,
                        current: visibleIndex !== null && visibleIndex !== void 0 ? visibleIndex : 0,
                        onVisibleChange: function (visible) {
                            if (!visible)
                                setVisibleIndex(null);
                        },
                    } }, { children: schemes.map(function (scheme, index) {
                        var _a;
                        return (_jsxs(SchemeCard, { children: [_jsxs(ImageContainer, __assign({ onClick: function () { return setVisibleIndex(index); }, style: { cursor: 'pointer', position: 'relative' } }, { children: [_jsx(DeleteButton, __assign({ onClick: function (e) {
                                                e.stopPropagation();
                                                handleDeleteScheme(scheme.id);
                                            } }, { children: _jsx(CloseOutlined, {}) })), _jsx(Image, { src: scheme.fileUrl, alt: scheme.fileName, style: { width: '100%', height: 200, objectFit: 'cover', borderRadius: 8 } })] })), _jsxs(InfoContainer, { children: [_jsx(FileName, { children: scheme.fileName }), ((_a = scheme.user) === null || _a === void 0 ? void 0 : _a.fullName) && (_jsxs(Author, { children: ["\u0410\u0432\u0442\u043E\u0440: ", scheme.user.fullName] })), scheme.isConfirmed && (_jsxs(ConfirmedBadge, { children: [_jsx(CheckCircleOutlined, { style: { color: '#52c41a', fontSize: 16 } }), _jsx("span", { children: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u043E" })] }))] }), _jsx(AntButton, __assign({ type: "primary", block: true, disabled: scheme.isConfirmed, onClick: function () { return handleConfirmScheme(scheme.id); }, style: { marginTop: 'auto' } }, { children: scheme.isConfirmed ? 'Подтверждено' : 'Подтвердить' }))] }, scheme.id));
                    }) })) })), _jsx(Modal, __assign({ title: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0441\u0445\u0435\u043C\u044B \u0432 \u043A\u0430\u0440\u0442\u044B \u0440\u0435\u0441\u0442\u043E\u0440\u0430\u043D\u0430", open: showUploadModal, onOk: handleUpload, onCancel: function () {
                    setShowUploadModal(false);
                    setSelectedFiles([]);
                }, okText: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C", cancelText: "\u041E\u0442\u043C\u0435\u043D\u0430" }, { children: _jsxs(UploadContainer, { children: [_jsx("input", { type: "file", multiple: true, accept: "image/*", onChange: handleFileSelect, style: { marginBottom: 16 } }), selectedFiles.length > 0 && (_jsxs("div", { children: [_jsxs("p", { children: ["\u0412\u044B\u0431\u0440\u0430\u043D\u043E \u0444\u0430\u0439\u043B\u043E\u0432: ", selectedFiles.length] }), selectedFiles.map(function (file, idx) { return (_jsx("p", __assign({ style: { fontSize: 12, color: '#666' } }, { children: file.name }), idx)); })] }))] }) }))] }));
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 20px;\n"], ["\n  padding: 20px;\n"])));
var Header = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n"])));
var Title = styled.h2(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-family: 'Montserrat Regular';\n  font-weight: 600;\n  font-size: 24px;\n  margin: 0;\n"], ["\n  font-family: 'Montserrat Regular';\n  font-weight: 600;\n  font-size: 24px;\n  margin: 0;\n"])));
var AddButton = styled.button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 10px 20px;\n  background: #e621d3;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: 'Montserrat Regular';\n  font-weight: 500;\n  font-size: 14px;\n\n  &:hover {\n    background: #d11bbf;\n  }\n"], ["\n  padding: 10px 20px;\n  background: #e621d3;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: 'Montserrat Regular';\n  font-weight: 500;\n  font-size: 14px;\n\n  &:hover {\n    background: #d11bbf;\n  }\n"])));
var SchemesGrid = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 20px;\n"], ["\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 20px;\n"])));
var SchemeCard = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  border: 1px solid #eee;\n  border-radius: 8px;\n  padding: 12px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n"], ["\n  border: 1px solid #eee;\n  border-radius: 8px;\n  padding: 12px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n"])));
var ImageContainer = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: relative;\n  margin-bottom: 12px;\n"], ["\n  position: relative;\n  margin-bottom: 12px;\n"])));
var DeleteButton = styled.button(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: rgba(0, 0, 0, 0.5);\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 1;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.7);\n  }\n"], ["\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: rgba(0, 0, 0, 0.5);\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 1;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.7);\n  }\n"])));
var InfoContainer = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  text-align: center;\n  margin-bottom: 12px;\n"], ["\n  text-align: center;\n  margin-bottom: 12px;\n"])));
var FileName = styled.p(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  font-weight: bold;\n  font-size: 14px;\n  margin: 0 0 8px 0;\n"], ["\n  font-weight: bold;\n  font-size: 14px;\n  margin: 0 0 8px 0;\n"])));
var Author = styled.p(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  font-size: 12px;\n  color: #555;\n  margin: 4px 0;\n"], ["\n  font-size: 12px;\n  color: #555;\n  margin: 4px 0;\n"])));
var ConfirmedBadge = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  margin-top: 8px;\n  color: #52c41a;\n  font-size: 12px;\n  font-weight: 500;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  margin-top: 8px;\n  color: #52c41a;\n  font-size: 12px;\n  font-weight: 500;\n"])));
var EmptyState = styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  text-align: center;\n  padding: 60px 20px;\n"], ["\n  text-align: center;\n  padding: 60px 20px;\n"])));
var EmptyText = styled.p(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  font-family: 'Montserrat Regular';\n  font-weight: 500;\n  font-size: 24px;\n  margin: 0 0 8px 0;\n"], ["\n  font-family: 'Montserrat Regular';\n  font-weight: 500;\n  font-size: 24px;\n  margin: 0 0 8px 0;\n"])));
var EmptySubtext = styled.p(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  font-family: 'Montserrat Regular';\n  font-size: 16px;\n  color: #666;\n  margin: 0;\n"], ["\n  font-family: 'Montserrat Regular';\n  font-size: 16px;\n  color: #666;\n  margin: 0;\n"])));
var UploadContainer = styled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  padding: 20px 0;\n"], ["\n  padding: 20px 0;\n"])));
var LoaderContainer = styled.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 400px;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 400px;\n"])));
export default SchemesTab;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;
